import { render, staticRenderFns } from "./DynamicProgramDetailPage.vue?vue&type=template&id=28f509df&scoped=true"
import script from "./DynamicProgramDetailPage.vue?vue&type=script&lang=js"
export * from "./DynamicProgramDetailPage.vue?vue&type=script&lang=js"
import style0 from "./DynamicProgramDetailPage.vue?vue&type=style&index=0&id=28f509df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f509df",
  null
  
)

export default component.exports